/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var COOKIEBAR_ID = 'cookie-bar';
var COOKIEBAR_BUTTON_ID = 'cookie-bar__consent-btn';
var COOKIEBAR_VISIBLE_CLASS = 'cookie-bar--visible';

var cookieBar = void 0;

function cookieConsent() {
    cookieBar = document.getElementById(COOKIEBAR_ID);

    if (cookieBar) {
        init();
    }
}

function init() {
    var cookieBarConsentBtn = document.getElementById(COOKIEBAR_BUTTON_ID);
    var hasCookie = document.cookie.match(/(?:(?:^|.*;\s*)bundles-cookie-consent\s*=\s*([^;]*).*$)|^.*$/)[1];

    if ((typeof hasCookie === 'undefined' || hasCookie === 'false') && cookieBar) {
        cookieBar.classList.add(COOKIEBAR_VISIBLE_CLASS);
    }

    if (cookieBarConsentBtn) {
        cookieBarConsentBtn.addEventListener('click', function (event) {
            event.preventDefault();
            document.cookie = 'bundles-cookie-consent=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
            cookieBar.classList.remove(COOKIEBAR_VISIBLE_CLASS);
        });
    }
}

exports.default = cookieConsent;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function videolink() {
    Array.prototype.slice.call(document.querySelectorAll('.js-videolink-placeholder')).forEach(function (placeholder) {
        var provider = placeholder.parentNode.getAttribute('data-video-provider');
        var id = placeholder.parentNode.getAttribute('data-video-id');

        if (provider && id) {
            setVideoPlaceholder(provider, id, placeholder);
        }
    });

    Array.prototype.slice.call(document.querySelectorAll('.js-videolink-play-link')).forEach(function (video) {
        video.addEventListener('click', function (event) {
            event.preventDefault();

            var provider = video.getAttribute('data-video-provider');
            var id = video.getAttribute('data-video-id');
            var videoContainer = video.parentNode.getElementsByClassName('js-videolink-container')[0];
            var template = createTemplate(provider, id);

            // Append the iframe to the video container
            video.parentNode.querySelector('.videolink__video-link').classList.add('videolink__video-link--hidden');
            videoContainer.appendChild(template);
        }, false);
    });
}

function createTemplate(provider, id) {
    var template = void 0;
    var url = void 0;

    switch (provider) {
        case 'youtube':
            url = '//www.youtube.com/embed/' + id + '?title=0&amp;byline=0&amp;portrait=0;&amp;badge=0&amp;autoplay=1';
            break;

        case 'vimeo':
            url = '//player.vimeo.com/video/' + id + '?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autoplay=1';
            break;

        case 'dailymotion':
            url = '//www.dailymotion.com/embed/video/' + id + '?autoplay=1';
            break;

        default:
            url = '';
            break;
    }

    if (url !== '') {
        template = document.createElement('iframe');
        template.setAttribute('src', url);
        template.setAttribute('webkitallowfullscreen', 'true');
        template.setAttribute('mozallowfullscreen', 'true');
        template.setAttribute('allowfullscreen', 'true');
        template.frameBorder = 0;
        template.style.width = '100%';
        template.style.height = '100%';
    } else {
        template = '<p>Sorry, this provider is not supported yet.</p>';
    }

    return template;
}

function setVideoPlaceholder(provider, id, element) {
    if (provider === 'youtube') {
        element.src = '//img.youtube.com/vi/' + id + '/maxresdefault.jpg';
    } else {
        var request = new XMLHttpRequest();
        var requestUrl = void 0;
        var response = void 0;
        var imgUrl = void 0;

        if (provider === 'vimeo') {
            requestUrl = 'http://vimeo.com/api/v2/video/' + id + '.json';
        } else if (provider === 'dailymotion') {
            requestUrl = 'https://api.dailymotion.com/video/' + id + '?fields=thumbnail_720_url';
        }

        request.open('GET', requestUrl, true);

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                response = JSON.parse(request.responseText);

                if (provider === 'vimeo') {
                    imgUrl = response[0].thumbnail_large;
                } else if (provider === 'dailymotion') {
                    imgUrl = response.thumbnail_720_url;
                }

                element.src = imgUrl;
            }
        };

        request.send();
    }
}

exports.default = videolink;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _cookieConsent = __webpack_require__(0);

var _cookieConsent2 = _interopRequireDefault(_cookieConsent);

var _videolink = __webpack_require__(1);

var _videolink2 = _interopRequireDefault(_videolink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
    (0, _cookieConsent2.default)();
    (0, _videolink2.default)();
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// web/frontend/js/bundle.js